import React from "react";
import "./ErrorPage.css";

const ErrorPage: React.FC = () => {
  return (
    <div className="error-container">
      <h2>Something went wrong</h2>
      <p>
        Please try refreshing the page or contact support if the problem
        persists.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="error-button"
      >
        Refresh Page
      </button>
    </div>
  );
};

export default ErrorPage; 